export default __webpack_public_path__ + "static/artificial-intelligence-102903adbd4068b0e8e0ce9784efb316.png";